.root {
  width: 100%;
  height: 100%;
  perspective: var(--rfp-perspective, 1000px);
}

.flipContainer {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform var(--rfp-duration, 0.8s) var(--rfp-easing, ease-in-out);
  transform-style: preserve-3d;
  will-change: transform;
}

.flipFrontFace,
.flipBackFace {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

/* The hidden face still sits in the DOM with full size — disable pointer events
 * so clicks on the visible face are not eaten by the back-facing one. */
.flipFrontFace[aria-hidden="true"],
.flipBackFace[aria-hidden="true"] {
  pointer-events: none;
}

@media (prefers-reduced-motion: reduce) {
  .flipContainer {
    transition: none;
  }
}
